<template>
    <div class="e-basic-input">
        <input type="text" v-model="fInput" @change="changed" />
    </div>
</template>

<script>
    import {EventBus} from '../../services/eventBus'

    export default {
    name: "BasicInput",
    props: {
      input: String,
      filtergroup: String,
      group: String,
      value: String,
      filterId: String
    },
    data () {
      return {
        fInput: ''
      }
    },
    methods: {
      changed () {
        let filter= {filtergroup: this.filtergroup, group: this.group, value: this.value, input: this.fInput, filterId:this.filterId}
        EventBus.$emit('setFilter', filter)
      }
    },
    mounted () {
      this.fInput = this.input
    }
  }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/elements/BasicInput.vue